 
import DataFetcherTemplateHome from "../../hooks/DataFetcherTemplateHome";

import ConectUs from "../../components/ConectUs";

import { motion } from "framer-motion";

import Modal from "../../components/Modal";
import ImageGallery from "../../components/ImageGallery";

import OfferTecnologias from "../../components/view/OfferTecnologias";
import DescuentosTecnologias from "./DescuentosTecnologias";
import OfferTecnologiasSemestral from "../../components/view/OfferTecnologiaSemestral";

const url =
  "https://be-ofertas.utpl.edu.ec/jsonapi/node/template_home/d96d6bca-b616-4a03-978c-54dd5fd4ba01" +
  "?include=field_imagen_portada.field_media_image,field_gallery.field_media_image" +
  "&fields[node--template_home]=title,field_gallery,field_imagen_portada,field_texto_portada,field_bloque1,field_bloque2,field_bloque3,field_bloque4" +
  "&fields[media--image]=field_media_image" +
  "&fields[file--file]=uri";

function Tecnologias() {
  const containerVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: "easeOut",
      },
    },
  };

  const DataDisplay = ({ data }) => {
    // Verificación estricta de galería
    const hasGallery = Array.isArray(data?.galeria)
      ? data.galeria.length > 0
      : Boolean(data?.galeria);

    return (
      <div>
        <div className="mt-[65px]">
          <img
            src={data.imagen_portada}
            alt="cabecera"
            className="w-full h-auto object-cover"
          />
        </div>

        {/* Sección: Contenedor centrado y ancho delimitado */}
        <section className="my-12 px-4 flex justify-center">
          <motion.div
            variants={containerVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            className="w-full max-w-3xl bg-gradient-to-br from-[#004270] via-[#002f52] to-slate-950 rounded-2xl shadow-xl border border-[#febe10]/20 p-8 md:p-10 flex flex-col items-center text-center gap-6"
          >
            {/* Texto y Botones (Estilo 100% estático, sin condicionales) */}
            <div
              dangerouslySetInnerHTML={{ __html: data.texto_portada }}
              className="w-full flex flex-col items-center text-center  
                /* Párrafos */
                [&_p]:text-slate-200
                        
                [&_h4]:text-[#febe10]
                  [&_h4]:mt-6
                 [&_h4]:text-lg
                [&_h4_strong]:text-lg
                 [&_h4]:p-0

                /* Título Principal h2 */
               
                [&_h2]:text-white
               [&_h2]:p-0
                [&_h2_strong]:text-[#febe10]

                /* Botón de acción principal */
                [&_a]:inline-flex
                [&_a]:items-center
                [&_a]:justify-center
                [&_a]:px-7
                [&_a]:py-3.5
                [&_a]:mt-4
                [&_a]:text-sm
                [&_a]:font-bold
                [&_a]:text-slate-950
                [&_a]:bg-[#febe10]
                [&_a]:hover:bg-[#e0a60b]
                [&_a]:rounded-xl
                [&_a]:shadow-md
                [&_a]:transition-all
                [&_a]:duration-200
                [&_a]:hover:scale-105
                [&_a]:mx-auto
              "
            />

            {/* Modal / Galería: solo se monta si existen elementos */}
            {hasGallery && (
              <div className="pt-4 border-t border-white/10 w-full flex justify-center [&_button]:text-white   [&_button]:font-bold [&_button:hover]:text-[#febe10] ">
                <Modal
                  title="Proceso de postulación y matrícula en el sistema académico"
                  content={
                    <div className="max-w-[350px] m-auto">
                      {" "}
                      <ImageGallery gallery={data.galeria} />
                    </div>
                  }
                />
              </div>
            )}
          </motion.div>
        </section>

        <section className="max-w-6xl m-auto px-6 sm:px-0">
          <div
            className="text-center"
            dangerouslySetInnerHTML={{ __html: data.bloque1 }}
          />
        </section>

        <section className="max-w-6xl m-auto px-6 sm:px-0">
          <div
            className="text-center"
            dangerouslySetInnerHTML={{ __html: data.bloque2 }}
          />
        </section>

        <div className="py-10">
          <OfferTecnologias></OfferTecnologias>
        </div>
        <section className="max-w-6xl m-auto px-6 sm:px-0">
          <div
            className="text-center"
            dangerouslySetInnerHTML={{ __html: data.bloque3 }}
          />
        </section>

        <div className="py-10">
          <OfferTecnologiasSemestral></OfferTecnologiasSemestral>
        </div>
        <div>
          <DescuentosTecnologias />
        </div>
      </div>
    );
  };

  return (
    <>
      <DataFetcherTemplateHome url={url}>
        {(data) => <DataDisplay data={data} />}
      </DataFetcherTemplateHome>

      <div className="padding2">
        <ConectUs
          facebook="https://www.facebook.com/utpltec/"
          instagram="https://www.instagram.com/utpltec/"
          tiktok="https://www.tiktok.com/@utpltec"
          x="https://twitter.com/utpl?lang=es"
          youtube="https://www.youtube.com/user/utpl/"
          linkedin="https://www.linkedin.com/company/utpl-tec/"
        />
      </div>
    </>
  );
}

export default Tecnologias;
